module.exports = __webpack_public_path__ + "img/7.2c28d66a.jpg";